import {IFunctionContainer} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';
import {Function, Param} from '@mintdata/mint-kit/api/decorators/Function';
import {SheetType} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AFrame} from '@mintdata/mint-kit/api/values/frames/AFrame';
import bind from 'bind-decorator';

export class SalesforceFunctions implements IFunctionContainer
{
    public get namespace()
    {
        return 'salesforce';
    }

    @Function({
        title: 'Read_Salesforce(params)',
        tip: 'Returns result of query execution against Salesforce. Data is inserted starting from location specified. Everything below and to the right will be cleared',
        example: 'READ_SALESFORCE(A1:C4, A6)',
        alias: 'READ_SALESFORCE',
        icon: '',
        returns:
            {
                type: Type.Frame,
                title: 'Result',
                tip: 'Returns result of the query execution'
            }
    })
    @bind
    public readSalesforce(
        @Param({
            title: 'Credentials',
            tip: 'Area that contains credentials to use and query to execute',
            type: Type.Frame
        }) args:AFrame,
        @Param({
            title: 'Location to insert data to',
            tip: 'Location where fetched data should be inserted',
            type: SheetType.SheetLocation
        }) insertTo:AFrame,
        @Param({
            title: 'Should add column names',
            tip: 'If true column names will be added as first row',
            type: Type.Boolean
        }) shouldAddCols:ABoolean,
        ):AFrame
    {
        return null;
    }

}
